const photographyLocations = {
  locations: [
    {
      name: 'Dwayne Watkins',
      code: 'dWatkins',
      country: 'Jamaica',
      img: 'https://cdn.sandals.com/beaches/v12/images/weddings/weddings-local-photographers/dWatkins-collage.jpg',

    },
    {
      name: 'Suki MacDonald Kapahi',
      code: 'suki',
      country: 'Jamaica',
      img: 'https://cdn.sandals.com/beaches/v12/images/weddings/weddings-local-photographers/suki-collage.jpg',
    },
    {
      name: 'Tiffany Lue Yen',
      code: 'tYen',
      country: 'Jamaica',
      img: 'https://cdn.sandals.com/beaches/v12/images/weddings/weddings-local-photographers/tYen-collage.jpg',
    },
    {
      name: 'Alan Smith',
      code: 'aSmith',
      country: 'Jamaica',
      img: 'https://cdn.sandals.com/beaches/v12/images/weddings/weddings-local-photographers/aSmith-collage.jpg',
    },
    {
      name: 'Christine Morden',
      code: 'cMorden',
      country: 'Turks',
      img: 'https://cdn.sandals.com/beaches/v12/images/weddings/weddings-local-photographers/cMorden-collage.jpg',
    },
    {
      name: 'James Roy',
      code: 'jRoy',
      country: 'Turks',
      img: 'https://cdn.sandals.com/beaches/v12/images/weddings/weddings-local-photographers/jRoy-collage.jpg',
    }
  ]
};

module.exports = photographyLocations;
